namespace RedBullMOBILE360.CustomerCare {
    export interface ThreeThreeZeroNotificationForm {
        Tcn: Serenity.StringEditor;
        PersonId: Serenity.StringEditor;
        TypeOfComplaint: Serenity.StringEditor;
        NotificationCounter: Serenity.IntegerEditor;
        ReportedIdentity: Serenity.StringEditor;
        ReporterList: Serenity.StringEditor;
        OperatorTcn: Serenity.StringEditor;
        ReportDate: Serenity.DateEditor;
        Status: Serenity.StringEditor;
        FirstActionDate: Serenity.DateEditor;
        SecondActionDate: Serenity.DateEditor;
        ActionType: Serenity.EnumEditor;
        UserCurrentStatus: Serenity.EnumEditor;
        ActivationDate: Serenity.DateEditor;
        NotificationSource: Serenity.EnumEditor;
    }

    export class ThreeThreeZeroNotificationForm extends Serenity.PrefixedContext {
        static formKey = 'CustomerCare.ThreeThreeZeroNotification';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ThreeThreeZeroNotificationForm.init)  {
                ThreeThreeZeroNotificationForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.EnumEditor;

                Q.initFormType(ThreeThreeZeroNotificationForm, [
                    'Tcn', w0,
                    'PersonId', w0,
                    'TypeOfComplaint', w0,
                    'NotificationCounter', w1,
                    'ReportedIdentity', w0,
                    'ReporterList', w0,
                    'OperatorTcn', w0,
                    'ReportDate', w2,
                    'Status', w0,
                    'FirstActionDate', w2,
                    'SecondActionDate', w2,
                    'ActionType', w3,
                    'UserCurrentStatus', w3,
                    'ActivationDate', w2,
                    'NotificationSource', w3
                ]);
            }
        }
    }
}
